import React, { useState, useEffect, useCallback, useRef } from 'react';
import {Form, InputGroup, Button, Modal, Col} from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import axios from 'axios';
import debounce from "lodash.debounce";
import * as consts from '../consts';

const animatedComponents = makeAnimated();
const DEFAULT_COUNTRY = consts.COUNTRIES_DATA[0];

function MCfilters(props) { 
    const isFirstRender = useRef(true);
    const [isUserCategoryGroup, setIsUserCategoryGroup] = useState(() => {return JSON.parse(sessionStorage.getItem('mcfilters-isucg')) || false});
    const [selectedCategoryGroup, setSelectedCategoryGroup] = useState(() => {return JSON.parse(sessionStorage.getItem('mcfilters-categorygroup')) || null});
    const [selectedCategory, setSelectedCategory] = useState(sessionStorage.getItem('mcfilters-category') || '');
    const [selectedState, setSelectedState] = useState(sessionStorage.getItem('mcfilters-state') || '');
    const [selectedOState, setSelectedOState] = useState(() => {return JSON.parse(sessionStorage.getItem('mcfilters-ostate')) || []});
    const [selectedCountry, setSelectedCountry] = useState(() => {return JSON.parse(sessionStorage.getItem('mcfilters-country')) || DEFAULT_COUNTRY});
    const [inputCountry, setInputCountry] = useState('');
    const [inputState, setInputState] = useState('');
    const [inputCategoryGroup, setInputCategoryGroup] = useState('');
    const [countries, setCountries] = useState(consts.COUNTRIES_DATA);
    const [states, setStates] = useState([]);
    const [clearAllVisible, setClearAllVisible] = useState(false);
    const [updatingRowData, setUpdatingRowData] = useState(false);

    const [categoryGroups, setCategoryGroups] = useState([]);
    const [categories, setCategories] = useState([]);
    const [popupCategories, setPopupCategories] = useState(false);
    const [inputCategory, setInputCategory] = useState('');
    const [inputCatGroup, setInputCatGroup] = useState(9999);
    const [multipleCategories, setMultipleCategories] = useState(() => {return JSON.parse(sessionStorage.getItem('mcfilters-multiplecategories')) || []});
    const [csvMultipleCategories, setCsvMultipleCategories] = useState(sessionStorage.getItem('mcfilters-csvcategories') || '');

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false; // Skip first run
            return;
        }

        if (props.listFilters) {
            handleCategoryGroupTypeChange({target: {checked: props.listFilters.filterIsUserCategoryGroup}});
            categoryGroupChange(props.listFilters.filterCategoryGroup);
            if(props.listFilters.filterMultipleCategories.length > 0){
            setMultipleCategories(props.listFilters.filterMultipleCategories.split(","));}
            props.pmcmc(props.listFilters.filterMultipleCategories);
            sessionStorage.setItem('mcfilters-csvcategories', props.listFilters.filterMultipleCategories);

            handleCategoryChange({target: {value: props.listFilters.filterCategory}});
            countryChange(countries.filter(row => row.code === props.listFilters.filterCountry)[0]);
            onStateChange(consts.STATES_DATA.filter(row => props.listFilters.filterState.split(",").includes(row.statecode))); 
        } else {
            resetFilterModel()
        }
    }, [props.listFilters])

    function closePopupCategories() {
        setPopupCategories(false)
    }

    function unselectAllPopupCategories() {
        setMultipleCategories([]);
        setCsvMultipleCategories('');
        sessionStorage.setItem('mcfilters-multiplecategories', JSON.stringify([]));
        sessionStorage.setItem('mcfilters-csvcategories', '')
        props.pmcmc('');
    }  

    useEffect(() => {
        if (props.switchToData.groupByCategory) {
            const categoryLabel = props.switchToData.category ?? '';
            const categoryRows = categories.filter(c => (c.label.toLowerCase() === categoryLabel.toLowerCase()));
            const categoryValue = (categoryRows && (categoryRows.length > 0)) ? categoryRows[0].value : 0;
            if (categoryValue > 0) {
                updatePopupCategories(categoryValue)
            }
        } else {
            const stateCode = props.switchToData.state ?? '';
            const stateRows = states.filter(s => (s.statecode.toLowerCase() === stateCode.toLowerCase()));
            const stateObject =  ((stateRows && (stateRows.length > 0)) ? stateRows : undefined);
            if (stateObject) {
                onStateChange(stateObject);
                props.pmcst(stateCode);
            }
        }
    }, [props.switchToData])

    function updatePopupCategories(currValue) {
        const currSelected = [...multipleCategories];
        const currOption = categories.filter(c => (c.value === currValue));
        const currIndex = currSelected.findIndex(s => (s.value === currValue));
        if (currIndex >= 0) {
            currSelected.splice(currIndex, 1)
        } else {
            currSelected.push(currOption[0]);
        }
        setMultipleCategories(currSelected);
        setSelectedCategory('');
        categoryGroupChange(null);
        sessionStorage.setItem('mcfilters-multiplecategories', JSON.stringify(currSelected));

        let csvCategories = '';
        if (currSelected.length > 0) {
            csvCategories = currSelected.map((c)=>c.label.replaceAll("'", "''")).join(",");
            csvCategories = `'${csvCategories}'`;
        }
        setCsvMultipleCategories(csvCategories);
        sessionStorage.setItem('mcfilters-csvcategories', csvCategories);
        props.pmcmc(csvCategories);
    }

    const loadCategories = () => {
        setUpdatingRowData(true);
        axios.get('/categories')
        .then(res => {
            setCategories(res.data);
            setUpdatingRowData(false);
        })
        .catch((error) => {
          console.log(error);
          setUpdatingRowData(false);
        })
    }

    const loadCategoryGroups = (isUcg) => {
        const serverURL = isUcg ? `/usercategorygroups/${props.loggedInUserId}` : '/categorygroups' ;

        setUpdatingRowData(true);
        axios.get(serverURL)
        .then(res => {
            setCategoryGroups(res.data);
            setUpdatingRowData(false);
        })
        .catch((error) => {
          console.log(error);
          setUpdatingRowData(false);
        })
    }

    useEffect(() => {
        countryChange(selectedCountry);
        loadCategories();
        loadCategoryGroups(isUserCategoryGroup);
    }, [])

    const handleCategoryGroupTypeChange = (e) => {
        const eChecked = e.target.checked;
        setIsUserCategoryGroup(eChecked);
        sessionStorage.setItem('mcfilters-isucg', JSON.stringify(eChecked));
        props.pmisucg(eChecked);
        categoryGroupChange(null);
        loadCategoryGroups(eChecked);
    }

    function categoryGroupChange(o) {
        setSelectedCategoryGroup(o);
        sessionStorage.setItem('mcfilters-categorygroup', JSON.stringify(o));
        props.pmccg(o);
    }

    const onCategoryGroupChange = (o) => {
        unselectAllPopupCategories();
        categoryGroupChange(o);
    }

    function onCategoryGroupMenuClose() {
        setInputCategoryGroup('')
    }

    const handleDebouncedCategoryChange = useCallback(
        debounce((eCategory) => {
            props.pmcca(eCategory);
        }, 500),
        []
    );

    function onCategoryGroupInputChange(value, e) {
        if (e.action === 'input-change') {
            setInputCategoryGroup(value)
        }
    }

    function handleCategoryChange(e) {
        const eCategory = e.target.value;
        setSelectedCategory(eCategory);
        sessionStorage.setItem('mcfilters-category', eCategory);
        handleDebouncedCategoryChange(eCategory);
    }

    function countryChange(o) {
        const selectedCountryId = o.value;
        
        setSelectedCountry(o);
        sessionStorage.setItem('mcfilters-country', JSON.stringify(o));
        sessionStorage.setItem('mcfilters-country-code', o.code);
        props.pmcco(o.code);
        setStates(consts.STATES_DATA.filter(s => (s.countryid === selectedCountryId)));
    }

    function onCountryChange(o) {
        countryChange(o); 

        setSelectedState('');
        setSelectedOState([]);
        sessionStorage.setItem('mcfilters-state', '');
        sessionStorage.setItem('mcfilters-ostate', JSON.stringify([]));
    }

    function onCountryInputChange(value, e) {
        if (e.action === 'input-change') {
            setInputCountry(value)
        }
    }

    function onCountryMenuClose() {
        setInputCountry('')
    }

    const handleDebouncedStateChange = useCallback(
        debounce((eState) => {
            props.pmcst(eState);
        }, 500),
        []
    );

    // useEffect(() => {
    //     handleDebouncedStateChange(selectedState)
    // }, [selectedState])

    function onStateChange(o) {
        setSelectedOState(o);
        sessionStorage.setItem('mcfilters-ostate', JSON.stringify(o));

        const multipleStates = o.map(s => s.statecode).join(',');
        setSelectedState(multipleStates);
        sessionStorage.setItem('mcfilters-state', multipleStates);

        handleDebouncedStateChange(multipleStates);
    }

    function onStateInputChange(value, e) {
        if (e.action === 'input-change') {
            setInputState(value)
        }
    }

    function onStateMenuClose() {
        setInputState('')
    }

    function resetFilterModel() {
        props.pmisucg(false);
        props.pmccg([]);
        props.pmcca('');
        props.pmcco(DEFAULT_COUNTRY.code);
        props.pmcst('');
        props.pmcmc('');

        setIsUserCategoryGroup(false);
        setSelectedCategoryGroup(null);
        setSelectedCategory('');
        setSelectedCountry(DEFAULT_COUNTRY);
        countryChange(DEFAULT_COUNTRY);
        setSelectedState('');
        setSelectedOState([]);
        setMultipleCategories([]);
        setCsvMultipleCategories('');

        sessionStorage.setItem('mcfilters-isucg', JSON.stringify(false));
        sessionStorage.setItem('mcfilters-categorygroup', null);
        sessionStorage.setItem('mcfilters-category', '');
        sessionStorage.setItem('mcfilters-country', JSON.stringify(DEFAULT_COUNTRY));
        sessionStorage.setItem('mcfilters-country-code', DEFAULT_COUNTRY.code);
        sessionStorage.setItem('mcfilters-state', '');
        sessionStorage.setItem('mcfilters-ostate', JSON.stringify([]));
        sessionStorage.setItem('mcfilters-multiplecategories', JSON.stringify([]));
        sessionStorage.setItem('mcfilters-csvcategories', '')
    }

    useEffect(() => {
        if (clearAllVisible) {
            resetFilterModel()
        }
    }, [props.forceReset])

    useEffect(() => {
        const cav = (selectedCountry.value !== DEFAULT_COUNTRY.value) || (Object.entries(selectedCategoryGroup ?? {}).length > 0) || (selectedCategory.length > 0) || (multipleCategories.length > 0) || (selectedState.length > 0);
        setClearAllVisible(cav);
        props.pcav("catalog",cav);
    }, [selectedCountry, selectedCategoryGroup, selectedCategory, multipleCategories, selectedState])

    return (<>
        <div className="p-2 border border-gray">
            <div className="mb-3 d-flex flex-row">
                <div style={{fontWeight: "700", fontSize: "13px"}}><i className="me-1 bi bi-card-list"></i>CATALOG</div>
                <div className={`ms-auto ${clearAllVisible && false ? 'd-flex' : 'd-none'}`} style={{color: "#ff3f6c", fontWeight: "700", fontSize: "13px", cursor: "pointer"}} onClick={resetFilterModel}>CLEAR ALL</div>
            </div>
            <Form id="frmMCatalogFilters" autocomplete="off">
                <div className="my-2">
                    <div className="d-flex flex-row">
                        <Form.Label id="lblCategoryGroup" for="ctlCategoryGroup">
                            {`${isUserCategoryGroup ? 'User' : 'System'} Category Group`}{updatingRowData ? (<>&nbsp;<i className="fa fa-spinner fa-pulse"></i></>) : ''}
                        </Form.Label>
                        <Form.Check id="ctlIsUserCategoryGroup" className="ms-auto" type="switch" checked={isUserCategoryGroup} disabled={false} onChange={handleCategoryGroupTypeChange} />
                    </div>
                    <Select
                        id='ctlCategoryGroup'
                        className={`sm border border-primary rounded catalog-step9`}
                        isMulti={false}
                        isClearable={true}
                        backspaceRemovesValue={true}
                        closeMenuOnSelect={true}
                        value={selectedCategoryGroup}
                        inputValue={inputCategoryGroup}
                        onInputChange={onCategoryGroupInputChange}
                        onChange={onCategoryGroupChange}
                        onMenuClose={onCategoryGroupMenuClose}
                        options={categoryGroups}
                        components={animatedComponents}
                        isDisabled={false}
                        isOptionDisabled={() => false}
                        menuPortalTarget={document.body}
                        styles={{ 
                            menuPortal: base => ({ ...base, zIndex: 9999 }), 
                            menu: (base) => ({...base,  width: "max-content", minWidth: "100%" }), 
                        }}
                    />
                </div>
                <div className="mb-2">
                    <div className="d-flex flex-row mb-1">
                        <Form.Label id="lblCategory" for="ctlCategory" className="my-auto">Category</Form.Label>
                        <Button size="sm" variant="outline-primary" className={`ms-auto border border-0 catalog-step8`} onClick={() => setPopupCategories(true)} disabled={false} >
                            <i className={`h6 bi bi-box-arrow-up-right`}></i>
                        </Button>
                    </div>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlCategory" data-value="Category" data-type="text" className="border border-primary" type="search" disabled={false} value={selectedCategory} onChange={handleCategoryChange}></Form.Control>
                    </InputGroup>
                </div>
                {(csvMultipleCategories.length > 0) ? (
                <div className="mb-2" style={{position: "relative"}}>
                    <Form.Control as="textarea" rows={multipleCategories.length} size="sm" id="ctlMultipleCategories" className="border border-primary" style={{ paddingRight: '2.5rem' }} readOnly={true} value={csvMultipleCategories} />
                    <Button variant="light" size="sm" style={{position: 'absolute', top: '2px', right: '16px', background: 'transparent', padding: '0.25rem 0.4rem', lineHeight: 1, fontSize: '1rem', zIndex: 2}} onClick={unselectAllPopupCategories} >&times;</Button>                
                </div>
                ) : ''}
                <div className="mb-2">
                    <Form.Label id="lblCountry" for="ctlCountry">Country</Form.Label>
                    <Select
                        id='ctlCountry'
                        className="sm border border-primary rounded catalog-step2"
                        isMulti={false}
                        isClearable={false}
                        backspaceRemovesValue={true}
                        closeMenuOnSelect={true}
                        value={selectedCountry}
                        onChange={onCountryChange}
                        options={countries}
                        components={animatedComponents}
                        onInputChange={onCountryInputChange}
                        onMenuClose={onCountryMenuClose}
                        inputValue={inputCountry}
                        isDisabled={props.disableCountry}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                <div className="mb-2">
                    <Form.Label id="lblState" for="ctlState">States/Territories</Form.Label>
                    <Select
                        id='ctlState'
                        className="sm border border-primary rounded"
                        isMulti={true}
                        isClearable={true}
                        backspaceRemovesValue={true}
                        closeMenuOnSelect={false}
                        value={selectedOState}
                        onChange={onStateChange}
                        options={states}
                        components={animatedComponents}
                        onInputChange={onStateInputChange}
                        onMenuClose={onStateMenuClose}
                        inputValue={inputState}
                        isDisabled={false}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
            </div>
            </Form>
            <Modal show={popupCategories} scrollable={true} size='lg' className='shadow-lg' onHide={closePopupCategories}>
                <Modal.Header className="py-2 bg-primary text-white">
                    <span className="fs-5">Select from over 4000+ business/industry categories</span>
                </Modal.Header>
                <Modal.Body className='d-flex flex-column overflow-hidden'>
                    <Col className={`flex-wrap d-flex`}>
                        <div className="w-100 d-flex flex-row mb-2 pe-1 bg-primary rounded" style={{height: "40px"}}>
                            <Form.Control 
                                className='m-1 w-100 rounded-pill' 
                                size="sm" 
                                type="text" 
                                placeholder="Search..." 
                                autoFocus
                                value={inputCategory}
                                onChange={(e) => setInputCategory(e.currentTarget.value)}
                            />
                            <Form.Control 
                                id='select_cgroup' 
                                as="select" 
                                className="w-25 my-auto main-font form-select rounded-pill" 
                                style={{height: "32px"}}
                                name="cgroup" 
                                value={inputCatGroup} 
                                onChange={(e) => setInputCatGroup(parseInt(e.currentTarget.value))} 
                            >
                                <option value={9999}>All</option>
                                {categoryGroups.map((e, key) => {  
                                    return <option key={key} value={e.value}>{e.label}</option>;  
                                })}  
                            </Form.Control>
                        </div>
                        <div className="overflow-auto" style={{height: "480px"}}>
                            {((inputCatGroup === 9999) ? categories : categories.filter(c => (c.categorygroupid === inputCatGroup))).filter(c => (c.label.toLowerCase().includes(inputCategory.toLowerCase()))).map((c, key) => {
                            return (
                            <Button 
                                size='sm'
                                className={`m-1 tog-btn`}
                                id={c.label}
                                key={key}
                                data-id={c.value}
                                type="button"
                                variant={`${multipleCategories.some(s => (s.value === c.value)) ? 'primary' : 'outline-primary'}`}
                                value={c.value}
                                onClick={() => {updatePopupCategories(c.value)}}
                                disabled={false}
                            >
                                {c.label}
                            </Button>
                            )})}
                        </div>
                    </Col>
                </Modal.Body>              
                <Modal.Footer>
                    <div className={`flex-fill ${(inputCatGroup >= 0) ? 'd-flex' : 'd-none'}`}>
                        <a target="_blank" href="https://drive.google.com/file/d/1L3BC9wGVMy1JF0S9iO9aAiiTaYk7oIhi/view?usp=sharing" alt="Download">
                            <Button id="download-pdf" size='sm'>Download <i className="bi bi-file-earmark-pdf"></i></Button>
                        </a>
                        <Button
                            size='sm'
                            className={`mx-1 tog-btn ${(multipleCategories.length === 0) ? 'd-none' : 'd-flex'}`}
                            id="unselect-all"
                            onClick={unselectAllPopupCategories}
                        >
                            <i className='bi bi-check-all'></i>&nbsp;Unselect All
                        </Button>
                    </div>
                    <div className='d-flex'>
                        <Button size='sm' variant="primary" onClick={closePopupCategories}>
                            OK
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    </>)
}

export default MCfilters;